import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import instance from "services/axiosServices";

interface Props extends QueryGlobalInterface {
  isSul?: boolean;
}

export function useListarUsuariosCorretores(props: Props) {
  const fetchData = async () => {
    const LISTAR_USUARIOS_CORRETORES = `identity/usuario/v1/listar-usuarios-corretores${
      props.isSul ? "?ativos=true" : ""
    }`;
    const response = await instance.get(LISTAR_USUARIOS_CORRETORES);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    retry: 0,
    // onError: (error: any) => {
    //   toast.error(`Erro ao buscar oportunidades. Tente novamente.`);
    //   console.error(error);
    // },
  });
  return query;
}
